import { apiRoutes } from "../../../_config/apiRoutes";
import { apiSlice } from "../../../_api/apiSlice";

export const walletApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getWalletBalance: builder.query({
      query: (companyId) => {
        const url = apiRoutes.wallet.getBalance.path.replace(
          ":companyId",
          companyId
        );
        return {
          url,
          method: apiRoutes.wallet.getBalance.reqType,
        };
      },
      // Transform the response to match our component format
      transformResponse: (response) => {
        // If response is already in the right format, return it
        if (Array.isArray(response)) {
          return response;
        }

        // Transform API response to component format
        const balances = [];

        // Handle the actual API response structure
        if (response.data && response.data.wallets) {
          // Find the billing unit with the highest balance
          let highestBalance = 0;
          let highestBalanceItem = null;

          // Process each wallet to find highest balance
          response.data.wallets.forEach((wallet) => {
            if (wallet.billingUnits && Array.isArray(wallet.billingUnits)) {
              wallet.billingUnits.forEach((billingUnit) => {
                const balance = parseFloat(billingUnit.balance) || 0;
                if (balance > highestBalance) {
                  highestBalance = balance;
                  highestBalanceItem = billingUnit;
                }
              });
            }
          });

          // Add only the highest balance item
          if (highestBalanceItem) {
            balances.push({
              id: "highest-balance",
              type: "credits",
              amount: parseFloat(highestBalanceItem.balance) || 0,
              label: highestBalanceItem.name,
              precision: 2,
              threshold: 100,
              buid: highestBalanceItem.BUID,
              billingUnitName: highestBalanceItem.name,
              unitName: highestBalanceItem.unitName,
            });
          }

          // Add company total balance
          if (response.data.totalBalance !== undefined) {
            balances.push({
              id: "company-total",
              type: "credits",
              amount: parseFloat(response.data.totalBalance) || 0,
              label: "Company Total Balance",
              precision: 2,
              threshold: 100,
            });
          }
        }

        // Fallback: If no specific balances found, create a default one
        if (balances.length === 0) {
          balances.push({
            id: "fallback",
            type: "credits",
            amount: 0,
            label: "No Balance Data",
            precision: 2,
            threshold: 100,
          });
        }

        // Return both the original response and transformed balances
        return {
          originalResponse: response,
          transformedBalances: balances,
          // For backward compatibility, also return balances directly
          ...balances,
        };
      },
    }),
  }),
});

export const { useGetWalletBalanceQuery } = walletApiSlice;
